module.exports = __webpack_public_path__ + "static/media/crossMask.dc023f68.svg";